import { ApolloClient, ApolloLink, ApolloProvider, createHttpLink, InMemoryCache } from '@apollo/client';
import { setContext } from '@apollo/client/link/context';
import { useAuth0 } from '@auth0/auth0-react';
import React from 'react';
import { getRequiredEnvironmentVariable } from './util';
// import { relayStylePagination } from '@apollo/client/utilities';

const uri = getRequiredEnvironmentVariable('REACT_APP_GRAPHQL_SERVER_URL');

const inMemoryCache = new InMemoryCache({
  // typePolicies: {
  //   Query: {
  //     fields: {
  //       // usersのQueryに対して、relayStylePaginationを適応する
  //       users: relayStylePagination(['type', 'query']),
  //     },
  //   },
  // },
});

export const AuthorizedApolloProvider: React.FC = ({ children }) => {
  const tokenRef = React.useRef<string>('');
  const { loginWithRedirect, getAccessTokenSilently } = useAuth0();

  const httpLink = React.useMemo(
    () =>
      createHttpLink({
        uri,
        fetchOptions: { credentials: 'same-origin' },
      }),
    []
  );

  const withTokenLink = React.useMemo(
    () =>
      setContext(async () => {
        // Use ref to avoid re-renders when token changes
        if (tokenRef.current) {
          return { auth0Token: tokenRef.current };
        }

        try {
          // getAccessTokenSilently has built-in cache from Auth0 SDK
          const newToken = await getAccessTokenSilently();
          tokenRef.current = newToken;
          return { auth0Token: newToken };
        } catch (e) {
          console.log(e);
          await loginWithRedirect();
        }
      }),
    [getAccessTokenSilently, loginWithRedirect]
  );

  const authLink = React.useMemo(
    () =>
      setContext((_, { headers, auth0Token }) => ({
        headers: {
          ...headers,
          ...(auth0Token ? { authorization: auth0Token } : {}),
        },
      })),
    []
  );

  // Create Apollo Client only once using useMemo
  const client = React.useMemo(
    () =>
      new ApolloClient({
        link: ApolloLink.from([withTokenLink, authLink, httpLink]),
        cache: inMemoryCache,
      }),
    [withTokenLink, authLink, httpLink]
  );

  return <ApolloProvider client={client}>{children}</ApolloProvider>;
};
